import { format } from 'date-fns';

function convertArrayOfObjectsToCSV(array) {
  if (array.length === 0) {
    return null;
  }

  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  const keys = Object.keys(array[0]);
  let result = '';

  // Add the header row
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  // Add each row of data
  array.forEach((item) => {
    const row = keys
      .map((key) => {
        // Handle null or undefined values
        if (item[key] === null || item[key] === undefined) {
          return '';
        }
        // Escape double quotes by doubling them
        const value = item[key].toString().replace(/"/g, '""');
        // Wrap the value in double quotes if it contains a comma, newline, or double quote
        if (
          value.indexOf(columnDelimiter) >= 0 ||
          value.indexOf(lineDelimiter) >= 0 ||
          value.indexOf('"') >= 0
        ) {
          return `"${value}"`;
        }
        return value;
      })
      .join(columnDelimiter);
    result += row + lineDelimiter;
  });

  return result;
}

export default function exportAsCsv(array, exportType) {
  const csv = convertArrayOfObjectsToCSV(array);
  if (csv == null) return;

  const filename = `${exportType}_${format(new Date(), 'yyyyMMdd-HHmmss')}.csv`;

  const link = document.createElement('a');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
